// @flow
import React, { Component } from "react";
import Helmet from "react-helmet";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import appleTouchIcon from "../images/apple-touch-icon.png";
import favicon32 from "../images/favicon-32x32.png";
import favicon16 from "../images/favicon-16x16.png";
import ogImage from "../images/og.png";
import config from "../../data/SiteConfig";
import "./base.css";
import "../../node_modules/mapbox-gl/dist/mapbox-gl.css";

type Props = {
  children: any
};

class Layout extends Component<Props, void> {
  render() {
    const { children } = this.props;
    return (
      <div style={{ paddingTop: "90px" }}>
        <Helmet>
          <title>{config.siteTitle}</title>
          <meta name="description" content={config.siteDescription} />
          <meta name="subject" content={config.siteDescription} />
          <meta
            name="google-site-verification"
            content="rwEw0qFn-ealLZQY48Q6wlA3RRzmpy-RMMZ1kwBKer4"
          />

          <link rel="apple-touch-icon" sizes="180x180" href={appleTouchIcon} />
          <link rel="icon" type="image/png" sizes="32x32" href={favicon32} />
          <link rel="icon" type="image/png" sizes="16x16" href={favicon16} />

          <meta property="og:title" content={config.siteTitle} />
          <meta property="og:description" content={config.siteDescription} />
          <meta property="og:image" content={ogImage} />
          <meta property="og:url" content={config.siteUrl} />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content={config.siteTitleShort} />

          <meta property="twitter:image" content={config.siteUrl + ogImage} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@templarbit" />
        </Helmet>
        <Header siteTitle={config.siteTitle} />
        <div>{children()}</div>
        <Footer />
      </div>
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/layouts/index.js